import axios from 'axios';

export default {
  fetchTom({
    commit,
  }, id) {
    return axios.get(`/tom/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'tom',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveTom(_, tom) {
    return axios.post('/tom', tom);
  },
  copyTom(_, tom) {
    return axios.post('/tom/copy', tom);
  },
  deleteTom(_, tom) {
    console.log(tom);

    return axios.delete(`/tom/${tom.id}`);
  },
};
